import { render, staticRenderFns } from "./folowing.vue?vue&type=template&id=ee26d22e"
import script from "./folowing.vue?vue&type=script&lang=js"
export * from "./folowing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports